import { render, staticRenderFns } from "./RedeemProduk.vue?vue&type=template&id=708e06ce&scoped=true"
import script from "./RedeemProduk.vue?vue&type=script&lang=js"
export * from "./RedeemProduk.vue?vue&type=script&lang=js"
import style0 from "./RedeemProduk.vue?vue&type=style&index=0&id=708e06ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e06ce",
  null
  
)

export default component.exports